import { mapState, mapActions } from 'vuex';
import Auth from '../api/auth';
import alertMixin from '../../shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  data() {
    return {
      inactivityTimeout: null,
      logoutWarningTimeout: null,
      warningShown: false,
    };
  },
  computed: {
    ...mapState('loginSetting', ['config']),
    logoutTime() {
      return (this.config.auto_logout_time || 15) * 60 * 1000; // Convert minutes to milliseconds
    },
    warningTime() {
      return this.logoutTime - 60 * 1000; // Always 1 minute before logout
    },
  },
  methods: {
    ...mapActions('loginSetting', ['fetch']),

    resetTimer() {
      clearTimeout(this.inactivityTimeout);
      clearTimeout(this.logoutWarningTimeout);

      if (!this.config.auto_logout_enabled) return; // Don't set timers if disabled
      // ⏳ Set a timeout to show the warning exactly 1 minute before auto logout
      this.logoutWarningTimeout = setTimeout(() => {
        if (!this.warningShown) {
          this.showLogoutWarning();
        }
      }, this.warningTime);

      // ⏳ Set the auto logout timer
      this.inactivityTimeout = setTimeout(() => {
        this.autoLogout();
      }, this.logoutTime);
    },

    showLogoutWarning() {
      this.showAlert(this.$t('AUTO_LOGOUT.WARNING')); // ⚠️ Show 1 min before logout
      this.warningShown = true;
    },

    async autoLogout() {
      this.showAlert(this.$t('AUTO_LOGOUT.MESSAGE')); // ⏳ Final logout alert
      Auth.logout();
      this.warningShown = false; // ✅ Reset flag after logging out
    },

    addEventListeners() {
      window.addEventListener('mousemove', this.resetTimer);
      window.addEventListener('keypress', this.resetTimer);
      window.addEventListener('click', this.resetTimer);
    },

    removeEventListeners() {
      window.removeEventListener('mousemove', this.resetTimer);
      window.removeEventListener('keypress', this.resetTimer);
      window.removeEventListener('click', this.resetTimer);
    },
  },

  async mounted() {
    await this.fetch(); // Load config from API
    this.addEventListeners();
    this.resetTimer();
  },

  beforeDestroy() {
    this.removeEventListeners();
    clearTimeout(this.inactivityTimeout);
    clearTimeout(this.logoutWarningTimeout);
  },
};
